import React from 'react';
import { Source, Layer, Popup } from 'react-map-gl/maplibre';

/**
 * Vector-tile sources and layers for a large dataset (hooks/useVectorTileLayers.js,
 * docs/VECTOR_TILES.md) plus the click popup. Rendered inside SurveyMap.
 */
export default function VectorTileLayers({ vt }) {
  if (!vt?.layers?.length) return null;
  return (
    <>
      {vt.layers.filter(l => l.visible).map(l => (
        <Source key={l.sourceId} id={l.sourceId} {...l.source}>
          <Layer id={l.layerId} type="circle" source-layer={l.sourceLayer} paint={l.paint} />
        </Source>
      ))}
      {vt.popup && (
        <Popup longitude={vt.popup.longitude} latitude={vt.popup.latitude} onClose={vt.closePopup}
          closeOnClick={false} anchor="bottom" maxWidth="320px">
          <div style={{ fontSize: 11, color: '#0b1220' }} data-testid="vt-popup">
            <div style={{ fontWeight: 600, marginBottom: 4 }}>{vt.popup.title}</div>
            <table>
              <tbody>
                {Object.entries(vt.popup.rows).map(([k, v]) => (
                  <tr key={k}>
                    <td style={{ paddingRight: 8, opacity: 0.7 }}>{k}</td>
                    <td>{v === undefined || v === null ? '' : String(v)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Popup>
      )}
    </>
  );
}

/** Status chip with per-layer toggles and the XYZ colour field (outside the map canvas). */
export function VectorTileStatus({ vt }) {
  if (!vt || vt.status === 'idle') return null;
  const box = {
    position: 'absolute', bottom: 36, left: 10, zIndex: 7, display: 'flex', flexDirection: 'column', gap: 4,
    padding: '6px 10px', borderRadius: 8, fontSize: 11, color: '#e6edf3',
    background: 'rgba(13,17,23,0.92)', border: '1px solid rgba(0,212,255,0.3)', maxWidth: 320,
  };
  if (vt.status === 'loading') return <div style={box}>Loading vector tiles…</div>;
  if (vt.status === 'error') return <div style={{ ...box, borderColor: 'rgba(248,113,113,0.5)' }} role="alert">{String(vt.error)}</div>;
  return (
    <div style={box} data-testid="vt-status">
      <div style={{ opacity: 0.75 }}>{vt.usePmtiles ? 'PMTiles archive' : 'Vector tiles'} (large dataset)</div>
      {vt.layers.map(l => (
        <label key={l.id} style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
          <input type="checkbox" checked={l.visible} onChange={() => vt.toggleLayer(l.id)} />
          <span>{l.name}{l.featureCount ? ` · ${Number(l.featureCount).toLocaleString()}` : ''}</span>
          {l.zFields.length > 1 && (
            <select value={l.zField || ''} onChange={e => vt.setZField(l.id, e.target.value)}
              style={{ fontSize: 11, background: 'transparent', color: 'inherit' }}>
              {l.zFields.map(f => <option key={f} value={f}>{f}</option>)}
            </select>
          )}
        </label>
      ))}
    </div>
  );
}
